const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};
const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};
class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }
  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }
  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }
  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }
  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }
  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }
  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }
  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}

/* Japan Shopping Chat Flow - Paste this into Assets > custom.js */
(function waitForChat() {
  var body = document.getElementById('jps-body');
  if (!body) { setTimeout(waitForChat, 200); return; }

  var steps = [
    { label:'Send Your Request', badge:'Step 1 / 6', ph:'Send a photo to get started...', msgs:[
      {t:'agent',lb:'Japan Shopping',html:'&#128075; Hey! Welcome to <strong>Japan Shopping</strong>. Need something you spotted on Instagram or a TV show?',ms:0},
      {t:'agent',lb:null,html:'Just send us a <strong>photo</strong> via WhatsApp or our form &mdash; we\'ll take care of the rest! &#127991;',ms:900}
    ]},
    { label:'Customer Sends Photo', badge:'Step 1 / 6', ph:'Sending your photo...', msgs:[
      {t:'user',lb:'You',img:'&#128444;',cap:'Screenshot from Instagram',html:'Hi! Can you find this bag? I saw it on Instagram &#128525;',ms:0}
    ]},
    { label:'We Search in Japan', badge:'Step 2 / 6', ph:'Waiting for our team...', msgs:[
      {t:'agent',lb:'Japan Shopping',html:'Got it! &#128588; Our team is now <strong>searching for this item in Japan</strong>...',ms:0},
      {t:'agent',lb:null,html:'We check stores &amp; online listings to find the exact item and best price. Hang tight! &#9203;',ms:900}
    ]},
    { label:'Our Quote', badge:'Step 3 / 6', ph:'Review your quote...', msgs:[
      {t:'agent',lb:'Japan Shopping - Found it!',img:'&#128717;',cap:'In-store - Shibuya, Tokyo',
       html:'Great news! We found your item &#127881; Here\'s your complete quote:',ms:0,
       price:{rows:[{l:'Item Price',v:'&yen;12,800'},{l:'Service Fee',v:'&yen;1,500'},{l:'Shipping',v:'FREE',free:true}],tot:{l:'Total',v:'&yen;14,300'}}}
    ]},
    { label:'Order Link & Payment', badge:'Step 4 / 6', ph:'Click the link to pay...', msgs:[
      {t:'agent',lb:null,html:'Ready to order? Here\'s your <strong>direct payment link</strong> &mdash; pay securely via Credit Card &#128179;',ms:0},
      {t:'agent',lb:null,html:'&#128279; <strong style="color:#E8002D">&#8594; tap here to pay securely</strong>',ms:700},
      {t:'user',lb:'You',html:'Payment done! &#9989;',ms:1400}
    ]},
    { label:'Shipped & Tracked!', badge:'Steps 5-6 / 6', ph:'Track your package...', msgs:[
      {t:'agent',lb:'Japan Shopping - Confirmed',html:'&#127882; Payment confirmed! We\'re packing your item now.',ms:0},
      {t:'agent',img:'&#128230;',cap:'Packed & Ready to Ship',lb:null,html:'Your package is wrapped up! Here\'s your tracking info:',ms:800,
       track:{num:'JP-384729-EMS',status:'Shipped from Tokyo - On the way!'}},
      {t:'agent',lb:null,html:'&#10024; <em>Need something else? Send us another photo anytime!</em>',ms:1600}
    ]}
  ];

  var step = 0, busy = false;
  var btn   = document.getElementById('jps-btn');
  var ph    = document.getElementById('jps-ph');
  var badge = document.getElementById('jps-badge');
  var dots  = document.getElementById('jps-dots');
  var rbtn  = document.getElementById('jps-restart');

  for (var di = 0; di < steps.length; di++) {
    (function(i) {
      var d = document.createElement('button');
      d.className = 'jps-dot';
      d.onclick = function() { if (!busy) { step=i; body.innerHTML=''; runStep(i,true); } };
      dots.appendChild(d);
    })(di);
  }

  function updDots() {
    var all = dots.querySelectorAll('.jps-dot');
    for (var i=0;i<all.length;i++) {
      all[i].className = 'jps-dot'+(i<step?' done':'')+(i===step?' active':'');
    }
  }

  function makeMsg(m) {
    var row = document.createElement('div');
    row.className = 'jps-msg '+m.t;
    var inner = m.t==='agent' ? '<div class="jps-mav">&#128717;</div>' : '';
    var bc = '';
    if (m.lb) bc += '<span class="jps-blabel">'+m.lb+'</span>';
    if (m.img) bc += '<div class="jps-bimg'+(m.t==='user'?' ui':'')+'"><span>'+m.img+'</span><div class="jps-icap">'+m.cap+'</div></div>';
    bc += '<div>'+m.html+'</div>';
    if (m.price) {
      bc += '<div class="jps-pcard">';
      for (var ri=0;ri<m.price.rows.length;ri++) {
        var r=m.price.rows[ri];
        bc += '<div class="jps-prow"><span>'+r.l+'</span><span class="'+(r.free?'jps-free':'')+'">'+r.v+'</span></div>';
      }
      bc += '<div class="jps-prow jps-tot"><span>'+m.price.tot.l+'</span><span>'+m.price.tot.v+'</span></div></div>';
    }
    if (m.track) {
      bc += '<div class="jps-tcard"><div class="jps-tnum">&#128230; '+m.track.num+'</div><div class="jps-tstat"><div class="jps-tdot"></div>'+m.track.status+'</div></div>';
    }
    inner += '<div class="jps-bub">'+bc+'</div>';
    row.innerHTML = inner;
    return row;
  }

  function showMsg(m, cb) {
    if (m.t==='agent') {
      var typ = document.createElement('div');
      typ.className = 'jps-typing';
      typ.innerHTML = '<div class="jps-mav">&#128717;</div><div class="jps-tbub"><div class="jps-td"></div><div class="jps-td"></div><div class="jps-td"></div></div>';
      body.appendChild(typ);
      body.scrollTop = body.scrollHeight;
      setTimeout(function() {
        typ.remove();
        body.appendChild(makeMsg(m));
        body.scrollTop = body.scrollHeight;
        setTimeout(cb, 250);
      }, 800);
    } else {
      body.appendChild(makeMsg(m));
      body.scrollTop = body.scrollHeight;
      setTimeout(cb, 250);
    }
  }

  function runMsgs(msgs, idx, cb) {
    if (idx >= msgs.length) { cb(); return; }
    var delay = idx===0 ? 0 : Math.max(300, msgs[idx].ms - msgs[idx-1].ms);
    setTimeout(function() {
      showMsg(msgs[idx], function() { runMsgs(msgs, idx+1, cb); });
    }, delay);
  }

  function runStep(i, animate) {
    busy = true;
    badge.textContent = steps[i].badge;
    ph.textContent = steps[i].ph;
    updDots();
    var div = document.createElement('div');
    div.className = 'jps-divider';
    div.innerHTML = '<span>'+steps[i].label+'</span>';
    body.appendChild(div);
    body.scrollTop = body.scrollHeight;
    if (!animate) {
      steps[i].msgs.forEach(function(m) { body.appendChild(makeMsg(m)); });
      body.scrollTop = body.scrollHeight;
      busy = false; updBtn(); return;
    }
    runMsgs(steps[i].msgs, 0, function() { busy=false; updBtn(); });
  }

  function updBtn() {
    if (step >= steps.length-1) { btn.innerHTML='&#10003;'; btn.style.background='#22C55E'; }
    else { btn.innerHTML='&#9654;'; btn.style.background='#E8002D'; }
  }

  btn.onclick = function() { if (!busy && step < steps.length-1) { step++; runStep(step, true); } };
  rbtn.onclick = function() {
    if (busy) return;
    step=0; body.innerHTML='';
    btn.innerHTML='&#9654;'; btn.style.background='#E8002D';
    runStep(0, true);
  };

  runStep(0, true);
})();